module.exports = __webpack_public_path__ + "img/uob.0ad1567d.png";